import { buildMenuCategories } from '@root/components/v2/SideOverlayTabMenu/buildMenuCategories';
import { Activity, Boxes, Bug, Container, Info, Layers, ListTree, Puzzle } from 'lucide-react';

// Flat vertical menu (no group headers) of the Kubernetes vulnerabilities side overlay (CVEs, images, workloads,
// SBOM), keyed by its `tab`.
const VULNERABILITY_TABS = {
  details: { label: 'Details', icon: Info },
  vulnerabilities: { label: 'Vulnerabilities', icon: Bug },
  runtime: { label: 'Runtime Analysis', icon: Activity },
  images: { label: 'Images', icon: Container },
  workloads: { label: 'Workloads', icon: Boxes },
  sbom: { label: 'SBOM', icon: ListTree },
  components: { label: 'Components', icon: Puzzle },
  layers: { label: 'Layers', icon: Layers },
};

// Which tabs an overlay of the given `type` shows. `hideImages` drops Images where the API has no images tab.
export const getVulnerabilityMenuCategories = (type, isStacked, hideImages = false) =>
  buildMenuCategories(
    [
      'details',
      ...(type !== 'cves' ? ['vulnerabilities'] : []),
      ...(type !== 'images' && !hideImages ? ['images'] : []),
      ...(type !== 'workloads' ? ['workloads'] : []),
      ...(type !== 'workloads' && type !== 'sbom' && type !== 'cves' ? ['sbom'] : []),
      ...(type === 'workloads' ? ['components'] : []),
      ...(type === 'images' ? ['layers'] : []),
      ...(type === 'cves' && isStacked ? ['runtime'] : []),
    ],
    undefined,
    key => ({ key, ...VULNERABILITY_TABS[key] }),
  );
